"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadSchLayers = exports.OrCadSchLayerMap = exports.ORCAD_SCH_LAYERSET = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const { SchLayerType } = sigma_engine_shared_1.DesignModels;
exports.ORCAD_SCH_LAYERSET = 'orcad-sch';
exports.OrCadSchLayerMap = {
    [SchLayerType.Label]: { id: 1, type: SchLayerType.Label, name: 'Label' },
    [SchLayerType.NameLabel]: { id: 2, type: SchLayerType.NameLabel, name: 'NameLabel' },
    [SchLayerType.ValueLabel]: { id: 3, type: SchLayerType.ValueLabel, name: 'ValueLabel' },
    [SchLayerType.Pin]: { id: 4, type: SchLayerType.Pin, name: 'Pin' },
    [SchLayerType.PinName]: { id: 5, type: SchLayerType.PinName, name: 'PinName' },
    [SchLayerType.PinNumber]: { id: 6, type: SchLayerType.PinNumber, name: 'PinNumber' },
    [SchLayerType.Symbol]: { id: 7, type: SchLayerType.Symbol, name: 'Symbol' },
    [SchLayerType.Junction]: { id: 8, type: SchLayerType.Junction, name: 'Junction' },
    [SchLayerType.BusJunction]: { id: 9, type: SchLayerType.BusJunction, name: 'BusJunction' },
    [SchLayerType.Wire]: { id: 10, type: SchLayerType.Wire, name: 'Wire' },
    [SchLayerType.Bus]: { id: 11, type: SchLayerType.Bus, name: 'Bus' },
    [SchLayerType.Other]: { id: 12, type: SchLayerType.Other, name: 'Other' },
    [SchLayerType.Background]: { id: 13, type: SchLayerType.Background, name: 'Background Contrast' },
    [SchLayerType.Image]: { id: 14, type: SchLayerType.Image, name: 'Image' },
};
exports.OrCadSchLayers = Object.values(exports.OrCadSchLayerMap);
//# sourceMappingURL=orcadLayers.js.map